import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';
import AuthBottom from 'components/AuthBottom';
import AuthTop from 'components/AuthTop';
import Input from 'components/Input';
import SupportButton from 'components/SupportButton';
import { numbersOnlyParse } from 'utils/fieldValidators';
import RewardsCards from 'resources/RewardsCards-2.png';
import './StartFormPage.css';

export const FORM_NAME = 'signUpForm';

class StartFormPage extends Component {
  constructor(props) {
    super(props);

    this.selectExistingCard = this.selectCard.bind(this, true);
    this.selectNewCard = this.selectCard.bind(this, false);
  }

  selectCard(hasCard) {
    this.props.triggerState({ hasCard }, true);
  }

  renderExistingOption() {
    const { existingRewardsNumber, pin } = this.props;
    return (
      <div className="has-card-option">
        <div className="option-title">{'Got a Rewards Card?'}</div>
        <div className="description-container">
          <img src={RewardsCards} alt="" />
          <div className="description-text">
            <div>
              {
                'Link your Wind Creek Rewards Card to a new WindCreekCasino.com '
              }
              {'account.'}
            </div>
            <div>
              {'Play games, win prizes, check rewards, socialize with '}
              {'members, and much more!'}
            </div>
          </div>
        </div>
        <div className="option-fields" aria-hidden="true">
          <Field
            name="existingRewardsNumber"
            component={Input}
            type="text"
            label="Rewards Account #*"
            autoComplete="off"
            inputMode="numeric"
            pattern="[0-9]*"
            disableOnSubmitting={true}
            hideErrors={true}
            hideWarnings={true}
            validationState={null}
            tooltip="Your 13-digit account number is printed on your Rewards Card"
            parse={numbersOnlyParse}
          />
          <Field
            name="pin"
            component={Input}
            type="password"
            label="PIN*"
            autoComplete="off"
            inputMode="numeric"
            pattern="[0-9]*"
            disableOnSubmitting={true}
            hideErrors={true}
            hideWarnings={true}
            validationState={null}
            parse={numbersOnlyParse}
          />
        </div>
        <button
          className="btn button-color-green"
          onClick={this.selectExistingCard}
          aria-label="Continue as an Existing Rewards Member"
          type="button"
          disabled={!(existingRewardsNumber && pin)}
        >
          Continue
        </button>
      </div>
    );
  }

  renderNewSignUp() {
    return (
      <AuthBottom className="start-form-bottom">
        <div className="option-title">New to Wind Creek?</div>
        <div className="option-description">
          {
            'Sign up now for a Wind Creek Rewards Card and access to WindCreekCasino.com. Collect your Rewards Card when you visit any Wind Creek Casino.'
          }
        </div>
        <button
          className="btn button-color-green sign-up-btn"
          onClick={this.selectNewCard}
          aria-label="Continue as a New Rewards Member"
          type="button"
        >
          SIGN UP
        </button>
        <SupportButton />
      </AuthBottom>
    );
  }

  render() {
    const { formRenderer } = this.props;

    const body = (
      <Fragment>
        <AuthTop hideLogo>
          <h2 className="sr-only focus-start" tabIndex="-1">
            Sign Up - Select Account Type
          </h2>
          <div className="form-page start-form-page">
            <div className="has-card-options">
              {this.renderExistingOption()}
            </div>
          </div>
        </AuthTop>
        {this.renderNewSignUp()}
      </Fragment>
    );

    const overrides = { submitText: '', backClass: 'embedded-hidden' };
    const pageProps = Object.assign({}, this.props, overrides);
    return formRenderer(pageProps, body);
  }
}

const formSelector = formValueSelector(FORM_NAME);
const mapStateToProps = createStructuredSelector({
  existingRewardsNumber: state => formSelector(state, 'existingRewardsNumber'),
  pin: state => formSelector(state, 'pin')
});

const withConnect = connect(mapStateToProps);

const reduxFormPage = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(StartFormPage);

// Don't include the rewards number and pin in the fields list.
// If there is an error, we don't want the user to go this page.
reduxFormPage.FormFields = [];

export default withConnect(reduxFormPage);
